import React, { FC, useMemo } from "react";
import { Button, Table, Upload, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { useStockBorrowDetailModel } from "./stockBorrowDetailsModel";
import { RouterParamType } from "@/model/navModel";
import { importPropsConfig } from "@/utils/importFile";
import { DetailType } from "@/types/ScmEnums";
import { IDetailList } from "../../stockOutAndInListType";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { formatNum, formatIntPoint, momentFormat } from "@/utils/utils";
import YhTag from "@/components/YhTag";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        setAddModalVisible,
        detailAddList,
        detailDataSource,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailEditForm,
        setDetaiAddDataRow,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailAddList,
        setDetailDataSource,
        modelScreenMethod,
        detailDetailList,
        storage,
        getDetailEditOne,
    } = useStockBorrowDetailModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const action = <>
        {mode !== "look" && <>
            <YhAuth resCode={ResourceAuthEnum.ST_M_BORROW_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => setAddModalVisible(true)}
                >新增配件</Button>
            </YhAuth>
            {mode != "edit" &&
                <YhAuth resCode={ResourceAuthEnum.ST_M_BORROW_ED_EDL_M}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={() => { detailDetailList(mode) }}
                    >批量删除</Button>
                </YhAuth>
            }
        </>}
    </>
    const ReturnIt = async (record: IDetailList) => {
        let { id, borrowCode } = detailEditForm
        let params = {
            id,
            borrowCode,
            details: [record]
        }
        let retData = await storage(params)
        if (retData) {
            message.success("还件成功")
            getDetailEditOne(borrowCode as string, "edit")
        }
    }
    const columns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件名称',
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '库存数量',
            width: 160,
            dataIndex: 'inventoryNums',
        }, {
            title: '借件数量',
            width: 160,
            dataIndex: 'borrowNum',
            editable: mode == "add" ? true : false,
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '还件时间',
            width: 160,
            dataIndex: 'returnTime',
            render: (text: any) => momentFormat(text)
            // editable: mode != "look" ? true : false,
        }, {
            title: '操作',
            // width: 120,
            fixed: "right",
            align: "center",
            render: (text: string, record: IDetailList, index: number) => (
                <YhTag onClick={() => ReturnIt(record)}
                    disabled={mode !== "edit"}
                    color="cyan"
                    text={"还件"}></YhTag>
            )
        }
    ];

    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": [],
    }

    const newSelectColumns = () =>
        columns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: record.returnTime ? false : col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockBorrow", "roleCodes": roles };
        return getRoleColumns("stockBorrow", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode]]);
    const handleSave = (row: IDetailList) => {
        let { inventoryNums, borrowNum } = row
        borrowNum = +formatIntPoint(borrowNum, inventoryNums, "借件数量>=库存数量")

        let newRow = {
            ...row,
            borrowNum
        }
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.uniqueId === item.uniqueId);
        const item = newData[index];

        // //判断仓库变化时，  重置货位
        // if (newRow.warehouseCode !== newData[index].warehouseCode) {
        //     newRow.shelfCode = undefined
        // }
        newData.splice(index, 1, { ...item, ...newRow });
        console.log(newData);

        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        // setTopButsControl(true)
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="配件信息" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.uniqueId as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}